module.exports = __webpack_public_path__ + "da5844eb35d2684d9b83ccc4c122bfb8.svg";